const actionTypes = {
    GET_BR_OUTPUT_RECORDS_SUCCESS: 'GET_BR_OUTPUT_RECORDS_SUCCESS',
    GET_RECON_MATCHED_DATA: 'GET_RECON_MATCHED_DATA',
    GET_BR_TOTALCOUNT_SUCCESS: 'GET_BR_TOTALCOUNT_SUCCESS',
    GET_ALLRECON_TOTALCOUNT_SUCCESS: 'GET_ALLRECON_TOTALCOUNT_SUCCESS',
    SET_RECON_EXPLORER_VIEWS: 'SET_RECON_EXPLORER_VIEWS',
    GET_RECON_MATCHED_GROUP: 'GET_RECON_MATCHED_GROUP',
    GET_RECON_SUMMARY_DATA: 'GET_RECON_SUMMARY_DATA',
    GET_SOURCE_SUMMARY_DATA: 'GET_SOURCE_SUMMARY_DATA',
    GET_EVENT_MONITORING_DATA: 'GET_EVENT_MONITORING_DATA',
};

export default actionTypes;